<template>
  <div v-if="music">
    <table class="table">
      <tbody>
        <tr>
          <th>ID</th>
          <td>{{ music.id }}</td>
        </tr>
        <tr>
          <th>Artist</th>
          <td>{{ music.artist }}</td>
        </tr>
        <tr>
          <th>Album</th>
          <td>{{ music.album }}</td>
        </tr>
        <tr>
          <th>Track Count</th>
          <td>{{ music.track_count }}</td>
        </tr>
        <tr>
          <th>Bonus Track Count</th>
          <td>{{ music.bonus_track_count }}</td>
        </tr>
        <tr>
          <th>Release Year</th>
          <td>{{ music.release_year }}</td>
        </tr>
        <tr>
          <th>Notes</th>
          <td>{{ music.notes }}</td>
        </tr>
        <tr>
          <th>Duration</th>
          <td>{{ music.duration }}</td>
        </tr>
      </tbody>
    </table>

    <router-link :to="{ name: 'MusicIndex' }" class="btn btn-secondary">Back</router-link>
  </div>

  <div v-else>
    There's actually nothing here.
  </div>
</template>

<script>

import { MusicService } from '@/common/services/music.service';

export default {
  name: 'MusicShow',
  components: {

  },
  props: [
    'id',
  ],
  data() {
    return {
      music: null,
    };
  },
  created() {
    this.getMusic(this.id);
  },
  methods: {
    getMusic(params) {
      MusicService.get(params).then((response) => {
        this.music = response.data;
      });
    }
  },
};

</script>

<style lang="scss" scoped>

</style>
